import { render } from "./PreviousRegister.vue?vue&type=template&id=6ae2ddc1"
import script from "./PreviousRegister.vue?vue&type=script&lang=js"
export * from "./PreviousRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__